import moment from 'moment'
import React, { useState } from 'react'
import { Drawer, Dropdown, Menu, Tabs } from 'antd'
import { Route, Switch, useHistory, Link, useParams } from 'react-router-dom'

import { AiOutlineDown } from 'react-icons/ai'

import { useToggle, stringifyDate, usePet, useListData, stringifyTime } from '../../modules'

import Receive from '../reusable/receive'
import DateRangePicker from '../reusable/rangePicker'

const { TabPane } = Tabs

const Account = ({ path, onClose }) => {
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(10)
    const [account, setAccount] = useState()
    const [string, setString] = useState('')
    const [ranges, setRanges] = useState([moment().startOf('day'), moment().endOf('day')])

    const history = useHistory()
    const { id } = useParams()

    const [visible, toggleVisible] = useToggle(true)

    const close = () => {
        toggleVisible()
        // onClose()
        setTimeout(() => history.goBack(), 300)
    }

    const [{ loading, error }, getAccount] = usePet('account', { id, page, limit }, { notify: true, callback: ({ data }) => setAccount(data) })

    const refresh = () => {
        getAccount()
    }

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            width="50%">
                {/* { JSON.stringify} */}
            <div className='flex justify-between'>
                <p className="font-extrabold text-3xl mb-0">{ account ? account?.name : 'Account Details' }</p>
                <div className="flex flex-col items-end pr-3 py-3">
                    <p className="font-semibold text-lg underline mb-2">Overview</p>
                    <p className="mb-1">Current Balance: Ksh. { account?.balance?.balance ?? 0 }</p>
                </div>
            </div>
            <div className="col-span-full xl:col-span-8 bg-white">
                {/* <div className="sm:flex sm:justify-between sm:items-center mb-8">
                    <input
                        onChange={e => search(e.target.value)}
                        className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                        id="grid-search"
                        type="text"
                        placeholder="Search using transaction ref" />
                    <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                        <DateRangePicker isClearable={ false } ranges={ ranges } selectRange={ selectRange } />
                    </div>
                </div> */}
                <Receive
                    error={error}
                    loading={loading}
                    progress>
                    {
                        account?.transactions?.length > 0 ?
                            <table className="table-auto w-full">
                                <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                    <tr>
                                        <th className="p-2">
                                            <div className="font-semibold text-center">No</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-left">Date</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-left">Debit</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-left">Credit</div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="text-sm font-medium divide-y divide-gray-100">
                                    {
                                        account?.transactions?.map((trans, key) =>
                                            <tr>
                                                <td className="p-2">
                                                    <div className="text-center">
                                                        { (key + 1)}
                                                    </div>
                                                </td>
                                                <td className="p-2">
                                                    <div className="">{ stringifyDate(trans.createdAt, true) }</div>
                                                    <p className="mb-0 text-gray-400 text-xs italic">{ stringifyTime(trans.createdAt) }</p>
                                                </td>
                                                <td className="p-2">
                                                    <div className="">{ Number(trans?.debit) }</div>
                                                </td>
                                                <td className="p-2">
                                                    <div className="">{ Number(trans?.credit) }</div>
                                                </td>
                                                <td className="p-2 text-center">
                                                </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                            :
                            <div className="w-full h-16 flex items-center justify-center">
                                <p className="font-semibold text-base">No entries were found</p>
                            </div>
                    }
                </Receive>
            </div>
        </Drawer>
    )
}

export default Account